module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.16e1d930cf13fb7a9563.woff";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff
// module id = 1477
// module chunks = 1